import classNames from 'classnames';
import React from 'react';

const Switch = ({ label, disable = false, value, onChange, className }) => {

  return (
    <label className={classNames('form-switch', className)} onClick={(e) => disable && e.preventDefault()}>
      <input type="checkbox" checked={value} onChange={onChange} />
      <i />
      <span>{label}</span>
    </label>
  );
};

export default Switch;
